
angular.module('bmsApp.training', [])

	.config([
		'$stateProvider',
		'$urlRouterProvider',
		'BMSPermission', function config(
			$stateProvider,
			$urlRouterProvider,
			BMSPermission
			) {

			$stateProvider

				.state('main.employee.index.training', {
					url: '/training',
					views: {
						'content@main.employee': {
							templateUrl: "ng/employee/training/templates/TrainingIndex.html",
							controller: 'TrainingIndexCtrl'
						},
						'side@main.employee': {
							templateUrl: "ng/employee/training/templates/TrainingIndexSide.html"
						}
					},
					ncyBreadcrumb: {label: 'Training'}
				})

				;

		}]);
